import gemImage from "../assets/images/gem.png"
import {useClientContext} from "../contexts/ClientContext"

export default function Balance() {

    const {frgBalance} = useClientContext()

    return (
        <div className={"relative flex flex-col my-8 items-center"}>
            <div className={'font-pixellari text-white'}>Gem Balance</div>
            <div className={"border-4 border-gray-600 rounded p-2 bg-gray-800"}>
                <div className={"flex items-center w-64"}>
                    <div className={"pr-2"}><img className={"h-8"} src={gemImage}/></div>
                    <div className={'text-gray-100 text-2xl font-pinwy'}>{Number(frgBalance).toFixed(3)}</div>
                </div>
            </div>
        </div>
    )
}
